import React from 'react';

type Props = {
  value: string | number;
};

const NotificationTrigger = ({ value }: Props) => {
  let label;
  switch (value) {
    case 'all_employees':
      label = 'All Employees';
      break;
    case 'account':
      label = 'Employees for Account';
      break;
    case 'venue':
      label = 'Employees for Venue';
      break;
    case 'event':
      label = 'Employees for Event';
      break;
    default:
      label = value;
  }
  return <div>{label}</div>;
};

export default NotificationTrigger;
